import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Accordion from '../Accordion/Accordion';
import ClearButton from '../ClearButton/ClearButton';
import './CategoryTree.less';
import Title from '../../common/shop/ShopFilters/Title/Title';
import { flatCategories } from '../utils/categoryTree';

/**
 * CategoryTree component - renders category tree
 * with a callback triggered on click
 */
export default function CategoryTree({
  categoryTreeList,
  activeKey,
  handleClick,
  enableCategoryClear,
  openSections,
  setOpenSections,
  handleClearAll,
}) {
  /**
   * Handles state management for when a title is clicked
   * @param {Object} item  - key and id of the item
   */
  const handleLabelClick = (item) => (e) => {
    e.preventDefault();

    const categoryKey = item.key || item.id;
    if (activeKey === categoryKey) return;

    handleClick(item);
  };

  const flattedCategories = useMemo(() => flatCategories(categoryTreeList), [categoryTreeList]);

  useEffect(() => {
    let parentKey = activeKey;
    const newOpenSections = {};

    while (parentKey) {
      newOpenSections[parentKey] = true;

      const parentNode = flattedCategories.find(
        // eslint-disable-next-line no-loop-func
        ({ id, key }) => id === parentKey || key === parentKey
      );

      if (!parentNode) break;
      parentKey = parentNode.parentCategory;
    }

    setOpenSections(newOpenSections);
  }, [activeKey]);

  return (
    <div className="category-tree__container">
      {activeKey && enableCategoryClear && <ClearButton handleClick={handleClearAll} />}

      <Title name="Category" />

      {categoryTreeList.map((parent, index) => (
        <Accordion
          key={index}
          parent={parent}
          activeKey={activeKey}
          openSections={openSections}
          handleLabelClick={handleLabelClick}
        />
      ))}
    </div>
  );
}

CategoryTree.propTypes = {
  categoryTreeList: PropTypes.arrayOf({
    id: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),

  handleClick: PropTypes.func,
  activeKey: PropTypes.string,
  openSections: PropTypes.shape({}),
  setOpenSections: PropTypes.func,
  handleClearAll: PropTypes.func,
  enableCategoryClear: PropTypes.bool,
};
